import OpenFridge from "@/components/OpenFridge";

export default function Interior() {
  return (
    <div className="relative min-h-screen kitchen-bg" data-testid="fridge-interior-page">
      <OpenFridge />
    </div>
  );
}
